export default "__VITE_ASSET__D2RQUXV4__"